import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetCriticalIncidentCase } from 'api/queries/incidentReportQuery';
import { useScreenSize } from 'components/Layout';
import { Spinner } from 'components/Shared';
import { CICaseSummary } from '../../components/CICaseSummary/CICaseSummary';
import { CICaseSummarySidePanel } from '../../components/CICaseSummary/CICaseSummarySidePanel/CICaseSummarySidePanel';
import { IncidentReportContextProvider } from '../../components/CICaseSummary/CICaseSummaryTabs/IncidentReportTab/IncidentReportContextProvider';
import type { CICaseDetail } from 'components/CriticalIncident/interfaces';

import './CICaseSummaryPage.scss';

export const CICaseSummaryPage: React.FC = () => {
    const { isMobile } = useScreenSize();

    const { caseId = '', activityId = '' } = useParams();
    const { data: ciCase } = useGetCriticalIncidentCase(Number(caseId), Number(activityId));

    const [drawerOpen, setDrawerOpen] = useState(false);

    // testing the SwipeableDrawer is tricky, so skipping these callbacks
    /* istanbul ignore next */
    const HandleDrawerOpen = useCallback(() => {
        setDrawerOpen(true);
    }, []);

    /* istanbul ignore next */
    const HandleDrawerClose = useCallback(() => {
        setDrawerOpen(false);
    }, []);

    if (!ciCase) {
        return (
            <div className="case_summary_page_container">
                <SwipeableDrawer
                    anchor={isMobile ? 'bottom' : 'left'}
                    variant={isMobile ? 'temporary' : 'permanent'}
                    open={drawerOpen}
                    onClose={HandleDrawerClose}
                    onOpen={HandleDrawerOpen}
                    className="case_summary_side_panel"
                >
                    <Spinner />
                </SwipeableDrawer>
                <Spinner />
            </div>
        );
    }

    return (
        <div className="case_summary_page_container">
            <IncidentReportContextProvider ciCase={ciCase as CICaseDetail}>
                <SwipeableDrawer
                    anchor={isMobile ? 'bottom' : 'left'}
                    variant={isMobile ? 'temporary' : 'permanent'}
                    open={drawerOpen}
                    onClose={HandleDrawerClose}
                    onOpen={HandleDrawerOpen}
                    className="case_summary_side_panel"
                >
                    <CICaseSummarySidePanel ciCase={ciCase as CICaseDetail} />
                </SwipeableDrawer>
                <CICaseSummary ciCase={ciCase as CICaseDetail} />
            </IncidentReportContextProvider>
        </div>
    );
};
